import { observer } from "mobx-react-lite";

import { useWorkoutEditStore } from "src/workouts/WorkoutEditContext";

import { InstructionsField } from "./InstructionsField";
import { useGroupUpdate } from "./useGroupUpdate";
import { VideoUrlPreview } from "./VideoUrlPreview";

interface FreestyleBodyFieldsProps {
  workoutItemId: string;
}

export const FreestyleBodyFields = observer(function FreestyleBodyFields(
  props: FreestyleBodyFieldsProps,
) {
  const workoutEditStore = useWorkoutEditStore();
  const workoutItem = workoutEditStore.getGroupWorkoutItemById(
    props.workoutItemId,
  );
  const { handleUpdate } = useGroupUpdate(props.workoutItemId);

  function handleStopPropagation(e: React.MouseEvent) {
    e.stopPropagation();
  }

  return (
    <div
      className="flex flex-col gap-3 px-2 pb-2"
      onClick={handleStopPropagation}
    >
      {workoutItem.media?.url ? (
        <div className="rounded-lg overflow-hidden border border-slate-200">
          <video
            src={workoutItem.media.url}
            controls
            className="w-full max-h-[200px] object-contain bg-black/5"
          />
        </div>
      ) : workoutItem.mediaUrl && !workoutItem.media?.url ? (
        <VideoUrlPreview url={workoutItem.mediaUrl} />
      ) : null}

      <InstructionsField
        value={workoutItem.instructions}
        onChange={(value) => {
          handleUpdate({ instructions: value });
        }}
      />
    </div>
  );
});
